import { createContext } from "react"

export const ThemeConfigContext = createContext({
  togglePaletteMode: () => {},
})
